import React from 'react'
import { Editor } from '@tinymce/tinymce-react'
import {
    Button,
    Chip,
    Input,
    InputLabel,
    makeStyles,
    MenuItem,
    Select,
    // TextField,
    useTheme,
} from '@material-ui/core'
import {
    Formik,
    Form as FormikForm,
    ErrorMessage,
    useFormikContext,
} from 'formik'
import { IMAGE_URL } from '../config/config'
import { uploadFile } from '../services/storage'
import { uploadFileAction } from '../redux/storage/storageAction'
import { useDispatch, useSelector } from 'react-redux'

// import {Form as BootstrapForm} from "react-bootstrap"

// import { withStyles } from "@material-ui/styles";

// const styles = {
//     root: {
//         marginLeft: 5
//     }
// }

// const BootstrapInput = withStyles(theme => ({
//     root: {
//       'label + &': {
//         marginTop: theme.spacing(3),
//       },
//     },
//     input: {
//       borderRadius: 4,
//       position: 'relative',
//       backgroundColor: theme.palette.common.white,
//       border: '1px solid #ced4da',
//       fontSize: 16,
//       width: 'auto',
//       padding: '10px 12px',
//       transition: theme.transitions.create(['border-color', 'box-shadow']),
//       // Use the system font instead of the default Roboto font.
//       '&:focus': {
//         boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
//         borderColor: theme.palette.primary.main,
//       },
//     },
//   }))(InputBase);

// const SpinnerAdornment = withStyles(styles)(props => (
//     <CircularProgress
//         className={props.classes.spinner}
//         size={20}
//     />
// ));

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
}

const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 5,
    },
    noLabel: {
        marginTop: theme.spacing(3),
    },
}))

function getStyles(name, listName, theme) {
    return {
        fontWeight:
            listName?.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    }
}

export const Form = props => (
    <Formik {...props}>
        {({ errors, touched }) => (
            <FormikForm
                className="needs-validation"
                noValidate=""
                errors={errors}
                touched={touched}
            >
                {props.children}
            </FormikForm>
        )}
    </Formik>
)

// export function CustomTextField(props) {
//   const {
//     name,
//     label,
//     placeholder,
//     value,
//     defaultValue,
//     handleChange,
//     wrapperClass,
//     labelClass,
//     inputClass,
//     ...rest
//   } = props;
//   return (
//     <div className={`mb-10 ${wrapperClass}`}>
//       <label className={labelClass} htmlFor={name}>
//         {label}
//       </label>
//       <input
//         placeholder={placeholder || ""}
//         type="text"
//         className={`form-control form-control-solid h-auto py-3 px-6 ${inputClass}`}
//         name={name}
//         value={value || ""}
//         defaultValue={defaultValue ? defaultValue : value ? value : ""}
//         onChange={handleChange && handleChange}
//         {...rest}
//       />
//       <ErrorMessage
//         name={name}
//         render={(msg) => (
//           <div style={{ color: "orangered", marginBottom: "5px" }}>{msg}</div>
//         )}
//       />
//     </div>
//   );
// }

export function CustomTextField(props) {
    const {
        name,
        label,
        placeholder,
        value,
        handleChange,
        wrapperClass,
        labelClass,
        inputClass,
        ...rest
    } = props
    return (
        <div className={`mb-10 ${wrapperClass}`}>
            <label className={labelClass} htmlFor={name}>
                {label}
            </label>
            <input
                placeholder={placeholder || ''}
                type="text"
                className={`form-control form-control-solid h-auto py-4 px-6`}
                name={name}
                value={value || ''}
                onChange={handleChange && handleChange}
                {...rest}
            />
            <ErrorMessage
                name={name}
                render={msg => (
                    <div style={{ color: 'orangered', marginBottom: '5px' }}>
                        {msg}
                    </div>
                )}
            />
        </div>
    )
}

export function SelectField(props) {
    const { value, title, data, handleChange, name, ...rest } = props
    return (
        <div className="mb-10">
            <InputLabel id="demo-simple-select-label">{title}</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                inputProps={{
                    name,
                    id: `formikSelector-${name}`,
                }}
                value={value}
                onChange={handleChange}
                {...rest}
            >
                <MenuItem value="">
                    <em> انتخاب </em>
                </MenuItem>
                {data?.length > 0
                    ? data?.map(({ name, id, value }) => (
                          <MenuItem key={id} value={value}>
                              {name}
                          </MenuItem>
                      ))
                    : null}
            </Select>
            <ErrorMessage
                name={name}
                render={msg => (
                    <div style={{ color: 'orangered', marginBottom: '5px' }}>
                        {msg}
                    </div>
                )}
            />
        </div>
    )
}
export const MultipleSelect = props => {
    const { title, value, onChange, data, ...rest } = props
    const theme = useTheme()
    const classes = useStyles()
    return (
        <div className="w-100 my-3">
            <InputLabel id="mutiple-checkbox-label">{title}</InputLabel>
            <Select
                labelId="mutiple-checkbox-label"
                id="mutiple-checkbox"
                multiple
                value={value}
                onChange={onChange}
                input={<Input />}
                renderValue={selected => (
                    <div className={classes.chips}>
                        {selected?.map(value => (
                            <Chip
                                key={value}
                                label={value}
                                className={classes.chip}
                            />
                        ))}
                    </div>
                )}
                MenuProps={MenuProps}
                {...rest}
            >
                {/*  */}
                {data?.map(({ id, name }) => (
                    <MenuItem
                        key={id}
                        value={name}
                        style={getStyles(name, value, theme)}
                    >
                        {name}
                    </MenuItem>
                ))}
            </Select>
            {/* <ErrorMessage name={name} render={msg =>
                <div style={{ color: 'orangered' ,marginBottom:"5px"}} >{msg}</div>
            } /> */}
        </div>
    )
}

export const Textarea = props => {
    const {
        label,
        name,
        placeholder,
        value,
        defaultValue,
        handleChange,
        ...rest
    } = props

    return (
        <div className="w-100 my-3">
            <label htmlFor={name}>{label}</label>
            <textarea
                placeholder={placeholder || ''}
                className={`form-control form-control-solid h-auto py-3 px-6 mb-10`}
                name={name}
                // value={value || ""}
                defaultValue={defaultValue || ''}
                onChange={handleChange && handleChange}
                rows={3}
                {...rest}
            />
            <ErrorMessage
                name={name}
                render={msg => (
                    <div style={{ color: 'orangered', marginBottom: '5px' }}>
                        {msg}
                    </div>
                )}
            />
        </div>
    )
}
// export const RadioButton = props =>{
//     const {selectedValue} = props;
//     return (
//         <Radio
//             checked={selectedValue}
//             onChange={handleChange}
//             value="a"
//             name="radio-button-demo"
//             inputProps={{ 'aria-label': 'A' }}
//       />
//     )
// }
// export const ImagePicker = (props) => {

//     return (
//         <ImageUpload {...props} />
//     )
// }

export function SubmitButton(props) {
    const { title, loading, ...rest } = props

    return (
        <Button
            type="submit"
            disabled={loading}
            className="px-3 btn-bg-gold"
            {...rest}
        >
            <span>{title}</span>
            {loading && (
                <span className="ml-3 spinner spinner-white px-4"></span>
            )}
        </Button>
    )
}

export function TextEditor({
    initialValue,
    init,
    name,
    label,
    setLoading,
    ...rest
}) {
    return (
        <>
            <label htmlFor="textEditor">{label}</label>
            <Editor
                id="textEditor"
                initialValue={initialValue}
                name={name}
                apiKey="d5t7lvyptpe9soy8wgqu89bwy54x3a95pm3d6qreo2tl1cs4"
                init={{
                    height: 500,
                    menubar: ['file', 'insert', 'view', 'format'],
                    plugins: [
                        'advlist autolink lists link image imagetools charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'directionality',
                        'insertdatetime media table paste code help wordcount hr toc',
                    ],
                    toolbar:
                        'undo redo | formatselect | ' +
                        'bold italic backcolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'image | hr | ltr rtl |' +
                        'removeformat | help',
                    //
                    content_style:
                        "@import url('https://v1.fontapi.ir/css/Shabnam:300');@import url('https://v1.fontapi.ir/css/Vazir'); body { font-size: 13px; font-family: Vazir,Shabnam}",
                    imagetools_toolbar:
                        'rotateleft rotateright | flipv fliph | editimage imageoptions',
                    font_formats: 'Vazir;Shabnam',
                    directionality: 'rtl',
                    language: 'fa',
                    file_picker_types: 'file image media',
                    images_upload_handler: async function(
                        blobInfo,
                        success,
                        failure
                    ) {
                        let imageFile = new FormData()
                        imageFile.append('file', blobInfo.blob())
                        const image_size = blobInfo.blob().size / 1000
                        if (image_size > 1024) {
                            failure(
                                'حجم تصویر انتخابی زیاد است( ' +
                                    image_size +
                                    ') ,حداکثر اندازه تصویر :' +
                                    1024 +
                                    ' kB میباشد'
                            )
                            return
                        } else {
                            alert('آپلوووود')
                            try {
                                const { data } = await uploadFile(imageFile)
                                // const {
                                //     data,
                                // } = await request.post(
                                //     '/storage/upload',
                                //     imageFile,
                                //     { auth: true }
                                // )
                                success(IMAGE_URL + data)
                            } catch (error) {
                                console.log(error)
                                return
                            }
                        }
                    },
                    ...init,
                }}
                {...rest}
            />
            <ErrorMessage
                name={name}
                render={msg => (
                    <div style={{ color: 'orangered', marginBottom: '5px' }}>
                        {msg}
                    </div>
                )}
            />
        </>
    )
}
